import * as Yup from 'yup';
import editCargoFormModel from './editCargoFormModel';

const {
  formField: {
    e_name,
    e_description,
    e_area
  }

} = editCargoFormModel;


export default [

  Yup.object().shape({ 
    [e_name.name]: Yup.string().required(`${e_name.requiredErrorMsg}`),    
    [e_description.name]: Yup.string().required(`${e_description.requiredErrorMsg}`),
    [e_area.name]: Yup.object().shape({
      value: Yup.string().required(),
      label: Yup.string().required()
    }).default(undefined) // 👈 
    .required(`${e_area.requiredErrorMsg}`),
  })
  
];  

    